export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/FilterOptionsComplier.worker.4bf7c204.js");
}
